import { client } from './api';

const ENDPOINT = 'Subscription';

class SubscriptionService {
  getAllSubscriptions = () => client.get(ENDPOINT);

  postSubscription = subscription => client.post(ENDPOINT, subscription);

  deleteSubscription = id => client.delete(`${ENDPOINT}/${id}`);
}

export default SubscriptionService;
